import { useContext, useLayoutEffect, useRef } from "react";
import "./ProjectsContainer.css";
import { GeneralContext } from "../../../hooks/GeneralContext";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default function ProjectsContainer() {
  const { projects } = useContext(GeneralContext);
  const rootRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.utils.toArray(".project-card").forEach((card) => {
        gsap.from(card, {
          y: 40, opacity: 0, duration: 0.7, ease: "power3.out",
          scrollTrigger: { trigger: card, start: "top 90%" },
        });
      });
    }, rootRef);
    return () => ctx.revert();
  }, [projects.length]);

  return (
    <div ref={rootRef} className="projects-wrap">
      <div className="projects-grid">
        {projects.map((project, i) => (
          <article key={project.name + i} className="project-card">
            <div className="pc-media">
              <img src={project.img} alt={project.name} loading="lazy" />
              <div className="pc-media-fade" />
              <span className="pc-index">0{i + 1}</span>
            </div>
            <div className="pc-body">
              <h3 className="pc-title">{project.name}</h3>
              <div className="pc-details">
                {project.details.map((detail, idx) => (
                  <p key={idx}>{detail}</p>
                ))}
              </div>
              <a className="pc-link" target="_blank" rel="noreferrer" href={project.link.trim()}>
                View project <span>→</span>
              </a>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
